/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { AvailableFlag } from './available-flag';
// May contain unused imports in some cases
// @ts-ignore
import { CommonManagementFlag } from './common-management-flag';
// May contain unused imports in some cases
// @ts-ignore
import { ContentTagWithExtensiveAttributeModel } from './content-tag-with-extensive-attribute-model';
// May contain unused imports in some cases
// @ts-ignore
import { ExtensiveAttributeValueResponse } from './extensive-attribute-value-response';
// May contain unused imports in some cases
// @ts-ignore
import { ExtensiveAttributeValueType } from './extensive-attribute-value-type';

/**
 * 拡張属性一覧情報
 * @export
 * @interface ExtensiveAttributeModel
 */
export interface ExtensiveAttributeModel {
    /**
     * 拡張属性定義ID
     * @type {string}
     * @memberof ExtensiveAttributeModel
     */
    'extensive_attribute_definition_id': string;
    /**
     * 拡張属性定義名称
     * @type {string}
     * @memberof ExtensiveAttributeModel
     */
    'extensive_attribute_definition_name'?: string;
    /**
     * 
     * @type {ExtensiveAttributeValueType}
     * @memberof ExtensiveAttributeModel
     */
    'value_type': ExtensiveAttributeValueType;
    /**
     * 説明文
     * @type {string}
     * @memberof ExtensiveAttributeModel
     */
    'description_text'?: string;
    /**
     * 
     * @type {CommonManagementFlag}
     * @memberof ExtensiveAttributeModel
     */
    'common_management_flag'?: CommonManagementFlag;
    /**
     * 
     * @type {AvailableFlag}
     * @memberof ExtensiveAttributeModel
     */
    'available_flag'?: AvailableFlag;
    /**
     * 区分値編集許可フラグ - 拒否：DENY - 許可：ALLOW 
     * @type {string}
     * @memberof ExtensiveAttributeModel
     */
    'value_edit_allow_flag'?: ExtensiveAttributeModelValueEditAllowFlagEnum;
    /**
     * 拡張属性区分値
     * @type {Array<ExtensiveAttributeValueResponse>}
     * @memberof ExtensiveAttributeModel
     */
    'extensive_attribute_value'?: Array<ExtensiveAttributeValueResponse>;
    /**
     * 拡張属性関連内容タグ一覧情報
     * @type {Array<ContentTagWithExtensiveAttributeModel>}
     * @memberof ExtensiveAttributeModel
     */
    'content_tags'?: Array<ContentTagWithExtensiveAttributeModel>;
}

export const ExtensiveAttributeModelValueEditAllowFlagEnum = {
    Deny: 'DENY',
    Allow: 'ALLOW'
} as const;

export type ExtensiveAttributeModelValueEditAllowFlagEnum = typeof ExtensiveAttributeModelValueEditAllowFlagEnum[keyof typeof ExtensiveAttributeModelValueEditAllowFlagEnum];


